 /* global define */

define('views/SearchResultView',[
	'jquery',
	'underscore',
	'backbone',
	'bootstrap',
	'text!templates/views/SearchResult.html'
], function($, _, Backbone, bootstrap, template) {

	'use strict';

	var Control = Backbone.View.extend({
		disableViewOnMapFlag : false,
		initialize: function() {
			_.bindAll(this);
		},
		render: function() {
			this.$modal = $(template);
			this.$modal.find('.btn-cancel').on('click', this.cancel);
			this.$modal.find('.btn-view-list').on('click', this.viewList);
			this.$modal.find('.btn-view-map').on('click', this.viewMap);
			this.$modal.find('.progressView').show();
			this.$modal.find('table').hide();
			this.$modal.modal('show');
			this.enableViewOnMap();
			return this;
		},
		disableViewOnMap: function(){
			this.disableViewOnMapFlag = true;
			this.$modal.find('.btn-view-map').addClass('disabled').css('opacity', '0.3');
		},
		enableViewOnMap: function(){
			this.disableViewOnMapFlag = false;
			this.$modal.find('.btn-view-map').removeClass('disabled').css('opacity', '1');
		},
		setMaxResults: function(size){

			var $maxResults = this.$modal.find('.max-results');

			if(!size || size === 0){

				$maxResults.hide();
				return;
			}

			$maxResults.find('span').text(size);
			$maxResults.show();

		},
		setCount: function(count){

			this.$modal.find('.progressView').hide();
			this.$modal.find('.search-results-count').html(count);

			if(count === '0'){
				this.$modal.find('.btn-view-list').hide();
				this.$modal.find('.btn-view-map').hide();
			}
			else{
				this.$modal.find('.btn-view-list').show();
				this.$modal.find('.btn-view-map').show();
			}

			this.$modal.find('table').show();

		},
		viewMap: function(){

			if(this.disableViewOnMapFlag === true){
				return;
			}

			this.trigger('viewMap');
			this.hide();
		},
		viewList:function(){
			this.trigger('viewList');
			this.hide();
		},
		cancel:function(){

			if(this.$modal){
				this.$modal.modal('hide');
				this.hide();
			}
		},
		hide:function(){

			if(this.$modal){
				this.$modal.modal('hide');
			}
		},
		isVisible:function(){
			if(this.$modal){
				return this.$modal.is(':visible');
			}
			return false;
		}
	});

	return Control;
});
